<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-box">
      <h3>确认下单</h3>
      <div style="font-size:14px;line-height:2">
        <div>类型：<strong>{{ orderTypeText }}</strong></div>
        <div>品种：<strong>{{ order ? (order.symbolName || order.symbol || 'XAUUSD') + ' ' + (order.lots || '0.01') + '手' : '' }}</strong></div>
        <div>建仓价格：<strong class="price-highlight">{{ order && order.price || '—' }}</strong></div>
        <div v-if="order && order.orderType === 'market'" class="bid-ask-info">
          <span class="ba-item">卖出价 {{ order.bidPrice || '—' }}</span>
          <span class="ba-item">买入价 {{ order.askPrice || '—' }}</span>
        </div>
        <div>杠杆：<strong>{{ order && order.leverage ? order.leverage + 'X' : '100X' }}</strong></div>
        <div>保证金：<strong>{{ order && order.margin != null ? order.margin.toFixed(2) + ' USD' : '—' }}</strong></div>
        <div>手续费：<strong>{{ order && order.fee != null ? order.fee.toFixed(5) + ' USD' : '—' }}</strong></div>
      </div>
      <div class="modal-btns">
        <button class="cancel" @click="close">取消</button>
        <button class="confirm" @click="confirmOrder">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import { showToast } from '@/utils/common'

export default {
  name: 'OrderConfirmModal',
  props: { visible: Boolean, order: Object },
  computed: {
    orderTypeText() {
      if (!this.order) return ''
      const isLimit = this.order.orderType === 'limit'
      const sideText = this.order.side === 'buy' ? '买入' : '卖出'
      return (isLimit ? '限价' : '市价') + sideText
    }
  },
  methods: {
    close() { this.$emit('close') },
    async confirmOrder() {
      try {
        await this.$store.dispatch('trade/placeOrder', this.order)
        showToast('下单成功')
        this.$emit('confirmed')
        this.close()
      } catch (e) { showToast(e.message || '下单失败') }
    }
  }
}
</script>

<style lang="scss" scoped>
.price-highlight { color: var(--red); font-size: 16px; }
.bid-ask-info { display: flex; gap: 16px; font-size: 12px; color: var(--text-secondary); padding: 4px 0; }
.ba-item { padding: 2px 8px; background: var(--bg); border-radius: 4px; }
.modal-btns { display: flex; gap: 12px; margin-top: 16px; button { flex: 1; padding: 10px; border-radius: 6px; border: none; cursor: pointer; font-family: inherit; font-weight: 600; } .cancel { background: var(--bg); } .confirm { background: var(--red); color: #fff; } }
</style>
